import React, { Component } from "react";

import { Icon } from "@culturehq/components";

const Option = ({ body, isActive, onSelect }) => (
  <div className="option" onClick={onSelect} role="button" tabIndex={0} aria-label={body}>
    <Icon icon={isActive ? "record" : "ios-circle-outline"} />{" "}
    <span>{body}</span>
  </div>
);

class MultiChoiceOneItem extends Component {
  constructor(props) {
    super(props);

    const { submittedResponse } = props;
    const { surveyItemResponseOptions } = submittedResponse || {};
    const responseOptionId = ((surveyItemResponseOptions || [])[0] || {}).id;

    this.state = { responseOptionId };
  }

  handleChange = responseOptionId => {
    const { onChange, surveyItem } = this.props;

    this.setState({ responseOptionId });

    if (onChange) {
      onChange({
        surveyItemId: surveyItem.id,
        surveyItemResponseOptionIds: [responseOptionId]
      });
    }
  };

  render() {
    const { surveyItem } = this.props;
    const { responseOptionId } = this.state;
    const { responseOptions } = surveyItem;

    return (
      <div className="SurveyItemMultiChoice">
        <div className="options">
          {responseOptions.map(({ id, body }) => (
            <Option
              key={id}
              body={body}
              isActive={responseOptionId === id}
              onSelect={() => this.handleChange(id)}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default MultiChoiceOneItem;
